import baseRepeat from "./component-library236.mjs";
import baseToString from "./component-library235.mjs";
import castSlice from "./component-library237.mjs";
import hasUnicode from "./component-library238.mjs";
import stringSize from "./component-library208.mjs";
import stringToArray from "./component-library239.mjs";
var nativeCeil = Math.ceil;
function createPadding(length, chars) {
  chars = chars === void 0 ? " " : baseToString(chars);
  var charsLength = chars.length;
  if (charsLength < 2) {
    return charsLength ? baseRepeat(chars, length) : chars;
  }
  var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
  return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
}
export {
  createPadding as default
};
